function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Tuy_App_Icon");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.88,79a2.21,2.21,0,0,1-2.05-3l5-12.43a24.48,24.48,0,0,1-5.19-15.07A25,25,0,0,1,32,29.92a30.07,30.07,0,0,1,39.93,0,25,25,0,0,1,8.37,18.54,24.58,24.58,0,0,1-4.49,14.12A2.21,2.21,0,0,1,72.21,60a20.17,20.17,0,0,0,3.7-11.59c0-12-10.72-21.69-23.91-21.69S28.09,36.49,28.09,48.45a20.24,20.24,0,0,0,5,13.26A2.21,2.21,0,0,1,33.45,64L30,72.56,40.09,68.1a2.21,2.21,0,0,1,1.76,0,26.12,26.12,0,0,0,21.81-.7,2.21,2.21,0,1,1,2,3.95A30.56,30.56,0,0,1,41,72.53L26.77,78.81A2.21,2.21,0,0,1,25.88,79ZM54.21,58.3v-12a2.21,2.21,0,1,0-4.43,0v12a2.21,2.21,0,0,0,4.43,0ZM52,36.5a2.21,2.21,0,0,0-2.21,2.21h0a2.21,2.21,0,0,0,4.43,0h0A2.21,2.21,0,0,0,52,36.5Z"
});

var SvgIcMessage = function SvgIcMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_message.4ce918f2.svg";
export { ForwardRef as ReactComponent };